module.exports = __webpack_public_path__ + "img/Flag_of_Christmas_Island.09db1384.svg";